module.exports = __webpack_public_path__ + "static/media/in_edit_green.326e3333.svg";